import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Circular from '../Circular/Circular';
import Button from "components/CustomButtons/Button.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Person, Phone, Description, Today, Update, Info, ViewModule, LocalShipping } from '@material-ui/icons';
import Moment from 'react-moment';
import moment from 'moment';
Moment.globalMoment = moment
Moment.globalLocale = 'pt-br'


const useStyles = theme => ({
    iconView : {
      color: "gray !important"
    },
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            width: 200
        }
    },
    note: {
        lineHeight: '1.5em'
    },
    dialog: {
        '& .MuiPaper-root':{
            margin: theme.spacing(1),
            width: 250,
            height: 250  
        }
    },
    green: {
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    },
    rowIcon: {
        display: "flex",
        alignItems: "center"
    },
    rowIcon2: {
        display: "flex",
        alignItems: "baseline"
    },
    titleBackColor: {
        background: '#61b956'
    }
  });

class SearchInfo extends Component {
    constructor(props) {
        super(props);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            waiting: true
        }
    }

    componentDidMount() {
        if(this.props.data)
            this.setState({waiting: false});   
        console.log(this.props.data);
        
    }

    handleClickOpen = () => {
        this.props.onChange(true);
    };

    handleClose = () => {
        this.props.onChange(false);
    };

    render() {
        const { classes, data } = this.props;

        return (
            <div>
                <Dialog className={(this.state.waiting) ? classes.dialog : null}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle className={classes.titleBackColor} id="alert-dialog-title">{(this.state.waiting) ? null : data.documentValue }</DialogTitle>
                    <DialogContent>
                    {(this.state.waiting) ? <div><Circular/></div> : 
                    <div>
                        <div className={classes.rowIcon}><LocalShipping/><b>{(data.carrierId) ? data.carrierId : '-'}</b></div>
                        <div className={classes.rowIcon}><ViewModule/><b>{(data.lockerName) ? data.lockerName : '-'}</b></div>
                        <div className={classes.rowIcon}><Person/><b>{(data.name) ? data.name + data.surName : '-'}</b></div>
                        <div className={classes.rowIcon}><Phone/><b>{(data.phone) ? data.phone : '-'}</b></div>
                        <div className={classes.rowIcon2}><Info/>
                            <p className={classes.note}>Criado em : <b>{(data.createdAto) ? <Moment format="DD/MM/YYYY HH:mm:SS">{data.createdAto}</Moment> : '-'}</b></p>
                            <p className={classes.note}>Reservado em : <b>{(data.reservedAt) ? <Moment format="DD/MM/YYYY HH:mm:SS">{data.reservedAt}</Moment> : '-'}</b></p>
                            <p className={classes.note}>Coletado em : <b>{(data.collectedAt) ? <Moment format="DD/MM/YYYY HH:mm:SS">{data.collectedAt}</Moment> : '-'}</b></p>
                        </div>
                    </div>}
                    </DialogContent>
                    <DialogActions>
                    {(this.state.waiting) ? null :
                    <div><Button onClick={this.handleClose} color="primary" autoFocus>
                        Fechar
                    </Button></div>}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default withStyles(useStyles)(SearchInfo);